// extracted by mini-css-extract-plugin
module.exports = {"button":"CreateNewButton_button__xgb4s"};